import { Component, Input, OnInit, inject } from '@angular/core';
import { Provider } from 'app/core/models/provider.model';
import { ProviderService } from 'app/core/services/provider.service';
import { ProviderOffice } from 'app/core/models/provider-office.model';
import { MatIcon } from '@angular/material/icon';
import { ProviderOfficeListBasicComponent } from '../provider-office-list-basic/provider-office-list-basic.component';
import { ProviderCallLogsComponent } from '../provider-call-logs/provider-call-logs.component';
import { InboundCallLogComponent } from '../inbound-call-log/inbound-call-log.component';
import { ProviderOutboundFaxesComponent } from '../provider-outbound-faxes/provider-outbound-faxes.component';

@Component({
    selector: 'app-provider-communications',
    templateUrl: './provider-communications.component.html',
    styleUrls: ['./provider-communications.component.scss'],
    imports: [MatIcon,
              ProviderOfficeListBasicComponent,
              ProviderCallLogsComponent,
              InboundCallLogComponent,
              ProviderOutboundFaxesComponent]
})
export class ProviderCommunicationsComponent implements OnInit {
  private providerService = inject(ProviderService);

  @Input() provider: Provider;
  providerOffices: ProviderOffice[];
  providerOfficesLoading = true;

  ngOnInit() {
    this.loadProviderOffices();
  }

  private loadProviderOffices() {
    this.providerService.getProviderOffices(this.provider.id).subscribe((providerOffices: ProviderOffice[]) => {
      this.providerOffices = providerOffices;
      this.providerOfficesLoading = false;
    });
  }
}
